import {Dispatch} from "redux";

import {addSuccessNotification} from "../../notifications/utils/add_success_notification";
import {alertFormSuccessMessage} from "../utils/form/application_form_alert_text";

export const afterPostApplicationActions = () => (dispatch: Dispatch) => {
    dispatch(addSuccessNotification(alertFormSuccessMessage));
};
